import { render, staticRenderFns } from "./IconoCompartido.vue?vue&type=template&id=30b96ff6&"
import script from "./IconoCompartido.vue?vue&type=script&lang=js&"
export * from "./IconoCompartido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30b96ff6', component.options)
    } else {
      api.reload('30b96ff6', component.options)
    }
    module.hot.accept("./IconoCompartido.vue?vue&type=template&id=30b96ff6&", function () {
      api.rerender('30b96ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IconoCompartido.vue"
export default component.exports